import {useCallback, useEffect} from "react";

export function useDebounceCallback(callback, delay, dependencies = []) {
    const debouncedCallback = useCallback(() => {
        const handler = setTimeout(() => {
            callback && callback(dependencies);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [callback, delay, ...dependencies]);

    useEffect(() => {
        return debouncedCallback();
    }, [debouncedCallback]);
}
